// frontend/src/pages/services/ServicesPage.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Smartphone, Wifi, Zap, Tv, BookOpen, ArrowLeft } from 'lucide-react';
import useWalletStore from '../../store/walletStore';

const ServicesPage = () => {
  const navigate = useNavigate();
  const { wallet } = useWalletStore();

  const formatAmount = (amount) => {
    return new Intl.NumberFormat('en-NG', {
      style: 'currency',
      currency: 'NGN',
      minimumFractionDigits: 0,
    }).format(amount || 0);
  };

  const services = [
    {
      id: 'airtime',
      name: 'Airtime',
      description: 'Recharge any Nigerian number',
      icon: Smartphone,
      iconColor: '#2563EB',
      bg: '#EFF6FF',
      route: '/airtime',
    },
    {
      id: 'data',
      name: 'Data',
      description: 'Data bundles for all networks',
      icon: Wifi,
      iconColor: '#7C3AED',
      bg: '#F5F3FF',
      route: '/data',
    },
    {
      id: 'electricity',
      name: 'Electricity',
      description: 'Prepaid & postpaid bills',
      icon: Zap,
      iconColor: '#D97706',
      bg: '#FFFBEB',
      route: '/bills',
    },
    {
      id: 'tv',
      name: 'TV',
      description: 'DSTV, GOtv, Startimes',
      icon: Tv,
      iconColor: '#059669',
      bg: '#ECFDF5',
      route: '/bills',
    },
    // Commented out for now
    // {
    //   id: 'education',
    //   name: 'Education',
    //   description: 'WAEC, NECO, NABTEB pins',
    //   icon: BookOpen,
    //   iconColor: '#7C3AED',
    //   bg: '#F5F3FF',
    //   route: '/bills',
    // },
  ];

  return (
    <div className="max-w-4xl mx-auto">
      {/* Header with Back Button */}
      <div className="flex items-center mb-4">
        <button
          onClick={() => navigate(-1)}
          className="mr-3 p-1.5 rounded-lg bg-white shadow-neomorph hover:shadow-neomorph-hover transition-all"
        >
          <ArrowLeft className="h-4 w-4 text-gray-600" />
        </button>
        <div>
          <div className="flex items-center">
            <div className="w-1 h-5 bg-gradient-to-b from-primary-400 to-primary-600 rounded-full mr-2" />
            <h1 className="text-lg font-bold text-gray-800">Services</h1>
          </div>
          <p className="text-xs text-gray-500 ml-3 hidden sm:block">
            Buy airtime, data, and pay bills
          </p>
        </div>
      </div>

      {/* Section Header */}
      <div className="flex items-center mb-4">
        <div className="w-1.5 h-1.5 rounded-full bg-primary-500 mr-2" />
        <h2 className="text-sm font-bold text-gray-700">Select Service</h2>
      </div>

      {/* Service Grid */}
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 sm:gap-4">
        {services.map((service) => (
          <button
            key={service.id}
            onClick={() => navigate(service.route)}
            className="bg-white rounded-xl p-4 sm:p-5 shadow-neomorph hover:shadow-neomorph-hover transition-all text-center border border-primary-100/30 group"
          >
            <div 
              className="w-12 h-12 sm:w-14 sm:h-14 rounded-xl mx-auto mb-3 flex items-center justify-center shadow-neomorph-inset"
              style={{ backgroundColor: service.bg }}
            >
              <service.icon size={22} color={service.iconColor} />
            </div>
            <h3 className="text-sm font-semibold text-gray-800 mb-0.5">
              {service.name}
            </h3>
            <p className="text-[10px] sm:text-xs text-gray-500">
              {service.description}
            </p>
          </button>
        ))}
      </div>

      <style jsx>{`
        .shadow-neomorph {
          box-shadow: 6px 6px 11px #d0d6e0, -6px -6px 11px #ffffff;
        }
        .shadow-neomorph-hover {
          box-shadow: 4px 4px 7px #d0d6e0, -4px -4px 7px #ffffff;
        }
        .shadow-neomorph-inset {
          box-shadow: inset 2.5px 2.5px 5px #d0d6e0, inset -2.5px -2.5px 5px #ffffff;
        }
      `}</style>
    </div>
  );
};

export default ServicesPage;